import React, { Suspense } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import  BusinessProposalComponent  from "./business-proposal";
import  SmartSuiteAgreementComponent from "./smart-suite-agreement";
import { PUBLIC_PREFIX_PATH,AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'
import Loading from 'components/shared-components/Loading';
import ApproveNotice from "./noticeApprove";
import { isUserLoggedIn } from "redux/reducers/loggedInUser";
import { useSelector } from "react-redux";
import AuthLayout from "layouts/auth-layout";
import { ConfigProvider } from "antd";
import AppLocale from 'lang';


const publicBusinessPropsal = ({ match }) => {
  const { locale, location, direction } = match;
  const isLoggedIn = useSelector(isUserLoggedIn);
  // localStorage.setItem("isPublic", true);  
  // const currentAppLocale = AppLocale[locale];

  const urlParams = new URLSearchParams(window.location.search);
   console.log("urlParams",urlParams)
  const emailReceiver = urlParams.get("emailReceiver");
const lockInEndDate = urlParams.get("lockInEndDate");
const newTerminationDate = urlParams.get("newTerminationDate");
const noofSeats = urlParams.get("noofSeats");
const clientName = urlParams.get("clientName");
const businesCenter = urlParams.get("businesCenter");
const clientId = urlParams.get("clientId");
const actionedBy = urlParams.get("actionedBy");
const agreementId = urlParams.get("agreementId");
const oldTerminationDate = urlParams.get("oldTerminationDate");
const initiatedBy = urlParams.get("initiatedBy");

const emailData = {"emailReceiver":emailReceiver,"lockInEndDate":lockInEndDate,"newTerminationDate":newTerminationDate, "oldTerminationDate": oldTerminationDate, "initiatedBy": initiatedBy,
    "noofSeats":noofSeats, "businesCenter":businesCenter,"clientId":clientId,"actionedBy":actionedBy,"clientName":clientName
 }

 const linkRestData = Object.entries(emailData)
 .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
 .join('&');
 
 const approveLink = `${window.location.href.split("/app")[0]}/public/noticeApproval?${linkRestData}`;

if(emailData.lockInEndDate !== null){
  localStorage.setItem("NoticeUrl",approveLink)
  localStorage.setItem("isPublic",true)
}
// Construct the approveLinkisPublic
let checks  = localStorage.getItem("NoticeUrl")

  console.log("hell",isLoggedIn)
  return (   
    <Suspense fallback={<Loading cover="page"/>}>
      {/* <ConfigProvider locale={currentAppLocale.antd} direction={direction}> */}
      <Switch>
        <Route path={`${PUBLIC_PREFIX_PATH}/businessProposal`} component={BusinessProposalComponent} />
        <Route path={`${PUBLIC_PREFIX_PATH}/smartSuiteAgreement`} component={SmartSuiteAgreementComponent} />        
        {/* {isLoggedIn ? (        
       
        ) : (
          null
            )} */}
            <Route path={PUBLIC_PREFIX_PATH}>
            {isLoggedIn ? (
              <Route path={`${PUBLIC_PREFIX_PATH}/noticeApproval`} component={ApproveNotice} /> 
            ) : (
              <Redirect to={AUTH_PREFIX_PATH + "/login"} />
            )}

          </Route>
        {/* <Redirect from={`${AUTH_PREFIX_PATH}`} to={`${AUTH_PREFIX_PATH}/login`} />  */}
              {/* <AuthLayout direction={direction} /> */}
        {/* <Redirect path={`${AUTH_PREFIX_PATH}/login`} to={`${AUTH_PREFIX_PATH}/login?${approveLink}`}/>  */}
        {/* <Redirect from={`${PUBLIC_PREFIX_PATH}`} to={`${PUBLIC_PREFIX_PATH}/businessProposal`} /> */}
        {/* <Redirect from={`${PUBLIC_PREFIX_PATH}`} to={`${PUBLIC_PREFIX_PATH}/smartSuiteAgreement`} /> */}
      </Switch>
      {/* </ConfigProvider> */}
    </Suspense>
  );
};

export default publicBusinessPropsal;
